import { useEffect, useRef } from 'react';
import { leaveToLogin } from '@/components/onboarding-hub/partASignOut';

/** /logout clears the session and opens the login page, including during company setup. */
export default function LogoutRoute({ onLogout }) {
  const onLogoutRef = useRef(onLogout);
  onLogoutRef.current = onLogout;
  useEffect(() => {
    leaveToLogin(() => onLogoutRef.current?.());
  }, []);
  return null;
}
